import availableHairColors from '@/helpers/hairColorHelper'
import availableEthnicities from '@/helpers/ethnicityHelper'
import availableGenders from '@/helpers/availableGendersHelper'

export default {
    profileFinder() {
        return this.$store.state.profileFinder
    },

    alreadySelectedUsers() {
        const self = this,
            profileSearches = self.$store.state.profileSearches.filter(profileSearch => {return profileSearch}),
            userIds = []

        profileSearches.forEach(profileSearch => {
            if (profileSearch.profiles) {
                let ids = profileSearch.profiles.map(profile => {
                    return profile?.user?.id
                })
                userIds.push(...ids)
            }
        })

        self.$store.state?.profileFinder?.profiles?.forEach(profile => {
            let id = profile?.user?.id ?? null
            if (id && !userIds.includes(id)) {
                userIds.push(id)
            }
        })

        return userIds
    },

    availableHairColors() {
        availableHairColors.unshift({
            color: 'Todas',
            code: null
        })

        return availableHairColors
    },
    availableEthnicities() {
        availableEthnicities.unshift({
            ethnicity: 'Todas',
            code: null
        })

        return availableEthnicities
    },
    availableGenders() {
        availableGenders.unshift({
            label: 'Todos',
            code: null
        })

        return availableGenders
    },
    favoriteIds() {
        return this.$store.state.session.favoriteWorkProfiles.map(profile => {return profile['@id']})
    }
}
